import { Helmet } from 'react-helmet-async';
import { Result } from 'antd';
import { useQuery } from 'react-query';
import { UserService } from '@/services';
import './style.scss';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTER } from '@/routes/routes';
import { useAuth } from '@/providers/Auth';
import { DASHBOARD_READERS, hasAnyPermission } from '@/utils/permission';

interface IProps {
  title?: string;
}

/** 権限に応じた最初のページ。管理者・閲覧専用ロールともダッシュボード */
const landingPath = (
  currentUser: ReturnType<typeof useAuth>['currentUser'],
): string | null => {
  if (hasAnyPermission(currentUser, DASHBOARD_READERS)) return APP_ROUTER.DASHBOARD;

  return null;
};

export const Home: React.FC<IProps> = ({ title }) => {
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useAuth();
  // Cookie の currentUser はログイン時のもの。ロール変更を反映するため入口で毎回取り直し、
  // 取り直した権限で currentUser を更新してから遷移する（遷移すると Home が外れるので、
  // onSuccess ではなく遷移と同じ effect で更新する）。前回のキャッシュで決めないよう
  // cacheTime: 0 にし、取得に失敗したときだけ Cookie の値で遷移する。
  const { data: me, isFetched } = useQuery(['getme'], () => UserService.getMe(), {
    cacheTime: 0,
  });
  const user = me?.data ?? (isFetched ? currentUser : null);
  const to = user ? landingPath(user) : null;

  useEffect(() => {
    if (me?.data) setCurrentUser(me.data);
    if (to) navigate(to, { replace: true });
  }, [me, to, navigate, setCurrentUser]);

  return (
    <div className='p-home'>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {user && !to && (
        <Result status='403' title='表示できるページがありません' subTitle='管理者に権限の付与を依頼してください。' />
      )}
    </div>
  );
};
